var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBurgerClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_454_514)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9099 21.4991L29.2099 17.2091C29.3982 17.0208 29.504 16.7654 29.504 16.4991C29.504 16.2328 29.3982 15.9774 29.2099 15.7891C29.0216 15.6008 28.7662 15.495 28.4999 15.495C28.2336 15.495 27.9782 15.6008 27.7899 15.7891L23.4999 20.0891L19.2099 15.7891C19.0216 15.6008 18.7662 15.495 18.4999 15.495C18.2336 15.495 17.9782 15.6008 17.7899 15.7891C17.6016 15.9774 17.4958 16.2328 17.4958 16.4991C17.4958 16.7654 17.6016 17.0208 17.7899 17.2091L22.0899 21.4991L17.7899 25.7891C17.6962 25.8821 17.6218 25.9927 17.571 26.1145C17.5203 26.2364 17.4941 26.3671 17.4941 26.4991C17.4941 26.6311 17.5203 26.7618 17.571 26.8837C17.6218 27.0055 17.6962 27.1161 17.7899 27.2091C17.8829 27.3028 17.9935 27.3772 18.1154 27.428C18.2372 27.4787 18.3679 27.5049 18.4999 27.5049C18.632 27.5049 18.7627 27.4787 18.8845 27.428C19.0064 27.3772 19.117 27.3028 19.2099 27.2091L23.4999 22.9091L27.7899 27.2091C27.8829 27.3028 27.9935 27.3772 28.1154 27.428C28.2372 27.4787 28.3679 27.5049 28.4999 27.5049C28.632 27.5049 28.7627 27.4787 28.8845 27.428C29.0064 27.3772 29.117 27.3028 29.2099 27.2091C29.3037 27.1161 29.3781 27.0055 29.4288 26.8837C29.4796 26.7618 29.5057 26.6311 29.5057 26.4991C29.5057 26.3671 29.4796 26.2364 29.4288 26.1145C29.3781 25.9927 29.3037 25.8821 29.2099 25.7891L24.9099 21.4991Z",
    fill: "#395FEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 2.5,
    width: 38,
    height: 38,
    rx: 19,
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_454_514",
    x: 0,
    y: 0,
    width: 47,
    height: 47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.705882 0 0 0 0 0.72549 0 0 0 0 0.780392 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_454_514"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_454_514",
    result: "shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerClose);
export default __webpack_public_path__ + "static/media/burger_close.6e222da9bfb1001bfc71d9fa8aa80b73.svg";
export { ForwardRef as ReactComponent };